export default "__VITE_ASSET__774c811a__"